// src/config/seoConfig.js
const seoConfig = {
    defaultTitle: "Vingroup Vinhomes - Dự án bất động sản cao cấp",
    defaultDescription: "Khám phá các dự án bất động sản Vinhomes cao cấp trên toàn quốc. Đầu tư sinh lời, vị trí vàng, tiện ích đẳng cấp.",
    defaultImage: "/images/og-default.jpg",
    siteUrl: "https://vinhomesdemo.com",
};

export default seoConfig;
